export const COM_AI_DRAWER_ID = 'drawer-view-comai' as const;
export const COM_AI_TERMS_DRAWER_ID = 'drawer-view-comai-terms' as const;
export const COM_AI_FEEDBACK_DRAWER_ID = 'drawer-view-comai-feedback' as const;
